import {ModuleWithProviders} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {OtSummaryComponent} from './ot-summary.component';

const routes: Routes = [
  {
    path: 'ot-summary/:id', component: OtSummaryComponent
  }
];
export const routing: ModuleWithProviders = RouterModule.forChild(routes);




// WEBPACK FOOTER //
// D:/CODE_REPOSITORIES/HIMS/HIMS_FRONTEND/src/app/ot-summary/ot-summary.routing.ts